import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@app/providers/useAuth';

interface PublicRouteProps {
  children: ReactNode;
}

/**
 * PublicRoute Component
 * 
 * Wraps routes that should only be accessible to unauthenticated users.
 * If the user is authenticated, redirects to the home page.
 */
export const PublicRoute: React.FC<PublicRouteProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="route-loading">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // If user is authenticated and tries to access login/landing, redirect to home
  if (isAuthenticated) {
    return <Navigate to="/home" replace />;
  }
  
  return <>{children}</>;
};

export default PublicRoute;
